import {
  CanvaModal,
  DragAndDrop,
  FlickrModal,
  GiphyModal,
  MediaBelt,
  MediaAttacherDropdown,
  PexelsModal,
  RecentlyUsedModal,
  URLModal,
  YoutubeModal,
  GoogleDriveModal,
} from './components';
import { useComposeBoxContext } from './composeBoxContext';
import { useEditorInteractions } from '../CreativeEditor/EditorInteractions';

export const MediaSystemComponents = () => {
  const {
    isCanvaModalOpen,
    isComposeBoxOpen,
    isFlickrModalOpen,
    isGiphyModalOpen,
    isPexelsModalOpen,
    isRecentlyUsedModalOpen,
    isURLModalOpen,
    isYoutubeModalOpen,
    isGoogleDriveModalOpen,
  } = useComposeBoxContext();

  useEditorInteractions();

  return (
    <>
      <MediaBelt />
      <MediaAttacherDropdown />
      {isCanvaModalOpen && <CanvaModal />}
      {isFlickrModalOpen && <FlickrModal />}
      {isGiphyModalOpen && <GiphyModal />}
      {isPexelsModalOpen && <PexelsModal />}
      {isRecentlyUsedModalOpen && <RecentlyUsedModal />}
      {isURLModalOpen && <URLModal />}
      {isYoutubeModalOpen && <YoutubeModal />}
      {isGoogleDriveModalOpen && <GoogleDriveModal />}
      {isComposeBoxOpen && <DragAndDrop />}
    </>
  );
};
